import type { ParsedUrlQuery } from 'querystring';

export const NEW_CARS_FLOW_LEVEL_COOKIE = 'newCarsFlowLevel';
export const NEW_CARS_HERO_SUPPRESSED_COOKIE = 'newCarsHeroSuppressed';

// Higher value = higher in the funnel. Hero hides on pages below the highest visited.
export const NEW_CARS_FLOW_LEVELS = {
  parentModel: 0,
  make: 1,
  new: 2
} as const;

export type NewCarsFlowLevel =
  (typeof NEW_CARS_FLOW_LEVELS)[keyof typeof NEW_CARS_FLOW_LEVELS];

export function parseFlowLevel(
  raw: string | undefined
): NewCarsFlowLevel | null {
  if (raw === undefined) return null;
  const parsed = Number(raw);

  return parsed === 0 || parsed === 1 || parsed === 2 ? parsed : null;
}

export function isFromPromoEntry(searchParams: ParsedUrlQuery): boolean {
  const promo = searchParams.promo;

  if (Array.isArray(promo)) return promo.some(value => value !== '');

  return promo !== undefined && promo !== '';
}

// Lets QA/support force the hero to show on every step of the flow via ?showHero=y,
// bypassing the flow-level and promo-suppression logic below.
export function isHeroForced(searchParams: ParsedUrlQuery): boolean {
  const showHero = searchParams.showHero;

  if (Array.isArray(showHero)) return showHero.includes('y');

  return showHero === 'y';
}

export function shouldShowHero(
  pageLevel: NewCarsFlowLevel,
  highestLevelVisited: NewCarsFlowLevel | null,
  arrivedFromPromo: boolean
): boolean {
  if (arrivedFromPromo) return false;

  return highestLevelVisited === null || pageLevel >= highestLevelVisited;
}
